import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import type { AppOperatingSystem } from "app/pages/sales-intelligence/modules/apps-search-filters/types/commonFiltersDto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { AppsColumnConfigDto } from "../../types/dto";
import { appsSearchQueryKeys } from "../key-factory/factory";

export const createAppsColumnConfigQuery = <T = AppsColumnConfigDto>(
    appOs: AppOperatingSystem | undefined,
    select?: (data: AppsColumnConfigDto) => T,
) =>
    queryOptions<AppsColumnConfigDto, unknown, T>({
        enabled: salesSettingsHelper.isConsolidatedAppsEnabled && !!appOs,
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: appsSearchQueryKeys.columnConfig(appOs),
        placeholderData: keepPreviousData,
        select,
        queryFn({ signal }) {
            return salesApiService.appsSearch.columnConfig.fetchColumnConfig(appOs!, { cancellation: signal });
        },
    });
